import { render, staticRenderFns } from "./CoverImageUpload.vue?vue&type=template&id=8a6db590&"
import script from "./CoverImageUpload.vue?vue&type=script&lang=js&"
export * from "./CoverImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports